module.exports = __webpack_public_path__ + "static/img/LOGO_OK.a8ea4b63.png";